import { Stack } from '@chakra-ui/react';
import AppRoutes from 'config/AppRoutes';
import { BusinessChoiceType } from 'features/utils/types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { resetAll, updateBusinessChoice } from 'store/answers/answersSlice';
import PageLayout from 'ui/layout/PageLayout';
import theme from 'ui/theme/theme';
import { useEffect, useState } from 'react';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import { AssetType, getAssetPath } from 'utils/hooks/useAsset';
import ChoiceContainer from './components/ChoiceContainer';

const PageBusinessChoice = () => {
  const currentRoute = AppRoutes.BUSINESS_CHOICE;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { navigateToNextStep } = useStepNavigation(currentRoute);
  const [shouldGoToNextStep, setShouldGoToNextStep] = useState(false);

  const b2cUrl = getAssetPath(AssetType.IMAGE, `/businessChoice/HOUSE.png`);
  const b2bUrl = getAssetPath(AssetType.IMAGE, `/businessChoice/SME.png`);

  const handleChoice = (choice: BusinessChoiceType) => {
    dispatch(resetAll(undefined));
    dispatch(updateBusinessChoice(choice));
    setShouldGoToNextStep(true);
  };

  // NOTE: using an effect to navigate to the next step so that the state is updated with the chosen flow
  useEffect(() => {
    if (shouldGoToNextStep) {
      navigateToNextStep();
    }
  }, [shouldGoToNextStep, navigateToNextStep]);

  return (
    <PageLayout
      title={t('BUSINESS_CHOICE_title')}
      titleStyle={{
        fontSize: { base: '24px', md: '36px' },
        position: { xl: 'relative' },
        top: { xl: '-50px' },
      }}
      layoutStyle={{
        background: theme.colors.reno.grey500,
        width: '90vw',
        justifyContent: 'center',
      }}
    >
      <Stack
        h={{ base: 'full', md: 'auto' }}
        pt="0px"
        w={{ base: 'full', md: 'full' }}
        gap={{ base: '10px', md: '25px' }}
        justifyContent="center"
        alignItems="center"
        direction={{ base: 'column', xl: 'row' }}
      >
        <ChoiceContainer
          title={t('BUSINESS_CHOICE_b2c_title')}
          assetUrl={b2cUrl}
          onContinue={() => handleChoice(BusinessChoiceType.B2C)}
          animIndex={0}
        />

        <ChoiceContainer
          title={t('BUSINESS_CHOICE_b2b_title')}
          assetUrl={b2bUrl}
          onContinue={() => handleChoice(BusinessChoiceType.B2B)}
          animIndex={1}
        />
      </Stack>
    </PageLayout>
  );
};

export default PageBusinessChoice;
